import { adjustAccordingToTimezone, extractQueryParamsToArray, getDateForIntervalFilter } from '../../utils/common';
import { ROUND_SPECIAL_FIELD_NAME, ROUND_SPECIAL_QUERY_PARAMS_NAME } from './constants';

export function formatRoundSpecialFilterValueToQueryParamsFormat(value, timezone) {
  const formattedFilter = [
    [ROUND_SPECIAL_QUERY_PARAMS_NAME.ROUND_ID, value[ROUND_SPECIAL_FIELD_NAME.ROUND_ID]],
    [ROUND_SPECIAL_QUERY_PARAMS_NAME.HIDE_ENDED_ROUNDS, value[ROUND_SPECIAL_FIELD_NAME.HIDE_ENDED_ROUNDS] ? 1 : 0]
  ];

  if (value[ROUND_SPECIAL_FIELD_NAME.LEAGUES].length) {
    value[ROUND_SPECIAL_FIELD_NAME.LEAGUES].forEach((leagueId) => {
      formattedFilter.push([ROUND_SPECIAL_QUERY_PARAMS_NAME.LEAGUES, leagueId]);
    });
  }

  if (
    value[ROUND_SPECIAL_FIELD_NAME.DATE_FILTER]?.from
    && value[ROUND_SPECIAL_FIELD_NAME.DATE_FILTER]?.to) {
    formattedFilter.push(
      [ROUND_SPECIAL_QUERY_PARAMS_NAME.START_DATE,
        adjustAccordingToTimezone(
          timezone, value[ROUND_SPECIAL_FIELD_NAME.DATE_FILTER].from,
        )],
    );
    formattedFilter.push(
      [ROUND_SPECIAL_QUERY_PARAMS_NAME.END_DATE,
        adjustAccordingToTimezone(
          timezone, value[ROUND_SPECIAL_FIELD_NAME.DATE_FILTER].to,
        )],
    );
  }

  return formattedFilter;
}

export function constructRoundSpecialsFilterFromQueryParams(queryParamsString, filterValue) {
  const extractedQueryParams = extractQueryParamsToArray(queryParamsString);
  const newFilterValue = structuredClone(filterValue);

  extractedQueryParams.forEach((query) => {
    const [key, value] = query;

    switch (key) {
      case ROUND_SPECIAL_QUERY_PARAMS_NAME.START_DATE:
        newFilterValue[ROUND_SPECIAL_FIELD_NAME.DATE_FILTER]
          .from = getDateForIntervalFilter(new Date(value));
        break;

      case ROUND_SPECIAL_QUERY_PARAMS_NAME.END_DATE:
        newFilterValue[ROUND_SPECIAL_FIELD_NAME.DATE_FILTER]
          .to = getDateForIntervalFilter(new Date(value));
        break;

      case ROUND_SPECIAL_QUERY_PARAMS_NAME.ROUND_ID:
        newFilterValue[ROUND_SPECIAL_FIELD_NAME.ROUND_ID] = parseInt(value);
        break;

      case ROUND_SPECIAL_QUERY_PARAMS_NAME.LEAGUES:
        newFilterValue[ROUND_SPECIAL_FIELD_NAME.LEAGUES].push(parseInt(value));
        break;

      case ROUND_SPECIAL_QUERY_PARAMS_NAME.HIDE_ENDED_ROUNDS: newFilterValue[ROUND_SPECIAL_FIELD_NAME.HIDE_ENDED_ROUNDS] = value === '1';
        break;

      default:
        newFilterValue[key] = value;
        break;
    }
  });
  return newFilterValue;
}
